module.exports = __webpack_public_path__ + "img/yinglifenxi.590bac94.png";